import React from 'react';
import { Divider, SimpleGrid, Text, VStack } from '@wegroup/design-system';
import { useFlowsSession } from '../../../../../../../flows/src/api/getFlowsSessionById';
import OffersOverviewRiskObjectBadge from './OffersOverviewRiskObjectBadge';
import { useTranslation } from 'react-i18next';

interface Props {
  sessionId: string;
  type: string;
}

const NewOffersOverviewSelectedRiskObjects: React.FC<Props> = ({
  sessionId,
  type,
}) => {
  const { t } = useTranslation();
  const { data: session } = useFlowsSession(sessionId);
  const riskObjectsByType = session?.risk_objects_revisions.filter(
    ({ type: riskObjectType }) => riskObjectType === type.toUpperCase(),
  );
  /** Only allow this for BIKMO = bicycles */
  if (type !== 'bicycle') return null;

  return (
    <>
      <VStack align="stretch" spacing="3">
        <Text textStyle="h6Headline">{t('Chosen risks')}:</Text>
        <SimpleGrid
          gap="3"
          columns={{ base: 1, tablet: 2, laptop: 2, laptopL: 3 }}
        >
          {riskObjectsByType?.map(({ id, self }) => {
            return (
              <OffersOverviewRiskObjectBadge key={id} type={type} self={self} />
            );
          })}
        </SimpleGrid>
      </VStack>
      <Divider color="gray.50" my="6" />
    </>
  );
};

export default NewOffersOverviewSelectedRiskObjects;
